import { render, staticRenderFns } from "./PaymentsData.vue?vue&type=template&id=73079920&scoped=true&"
import script from "./PaymentsData.vue?vue&type=script&lang=ts&"
export * from "./PaymentsData.vue?vue&type=script&lang=ts&"
import style0 from "./PaymentsData.vue?vue&type=style&index=0&id=73079920&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73079920",
  null
  
)

export default component.exports